import React from 'react';

import {QRCODE_API_URL} from 'app/urls';

interface Props {
  contentType: 'procedure' | 'proceduregroup' | 'policy' | 'document';
  hashid: string;
  alt?: string;
  className?: string;
  style?: React.CSSProperties;
}

export function QRCodeImage({
  contentType,
  hashid,
  ...other
}: Props): JSX.Element {
  const qrCodeURL = `${QRCODE_API_URL}${contentType}-${hashid}`;
  return <img {...other} src={qrCodeURL} />;
}
